module.exports = __webpack_public_path__ + "img/main-pic.1d39cc72.png";